import React from "react";
import { Container } from "react-bootstrap";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import "./style.scss";
import { Base } from "../../components/RootLayout";

const SupportChatPage = () => {
  return (
    <Base>
      <div className="chat-support h-100">
        <TopNavigation
          titlePage="Chat"
          toPath={PageRoutes.support}
          setBorder={true}
          showRightIcon={false}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
        />
        <Container className="iframe-chat">
          <iframe
            className="responsive-iframe"
            src="https://tawk.to/chat/6577dc6e07843602b8012de4/1hhe3a4l9"
            title="Tawk IO"
          />
        </Container>
      </div>
    </Base>
  );
};

export default SupportChatPage;
